import * as z from "zod";

export const getGoogleAdsOAuthURL = {
  name: "getGoogleAdsOAuthURL" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
